import React from "react";
import { Box, List, ListItem, Typography } from "@mui/material";
import PolicyIcon from "@mui/icons-material/Policy";

const menuItems = ["FAQs", "Policy"];
interface SidebarProps {
  activeIndex: number;
  setActiveIndex: (idx: number) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeIndex, setActiveIndex }) => {
  return (
    <Box
      sx={{
        width: 190,
        bgcolor: "#fff",
        height: "100vh",
        pt: 3,
        borderRadius: "4px",
        display: "flex",
        justifyContent: "center",
        mx: "10px",
      }}
    >
      <List
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {menuItems.map((label, idx) => (
          <ListItem disablePadding key={label} sx={{ width: "100%" }}>
            <Box
              onClick={() => setActiveIndex(idx)}
              sx={{
                bgcolor: activeIndex === idx ? "#111" : "#fff",
                color: activeIndex === idx ? "#fff" : "#222",
                borderRadius: 2,
                width: "100%", // full width
                height: 41,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                px: 2, // left and right padding
                py: 1, // top and bottom padding
                cursor: "pointer",
                "&:hover": {
                  bgcolor: activeIndex === idx ? "#111" : "#f5f5f5",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "& img": {
                    filter:
                      activeIndex === idx
                        ? "brightness(0) invert(1)"
                        : "brightness(0)",
                  },
                  "& .MuiSvgIcon-root": {
                    color: activeIndex === idx ? "#fff" : "#000",
                  },
                }}
              >
                {label === "FAQs" ? (
                  <img
                    src="/svgs/Faq.svg"
                    alt="FAQ"
                    style={{ width: 22, height: 22 }}
                  />
                ) : (
                  <PolicyIcon style={{ width: 22, height: 22 }} />
                )}
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {label}
              </Typography>
            </Box>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Sidebar;
